import { AppRoot, MainLogo, SuspenseErrorState } from "@bsm/component";
import React from "react";
import { useHareaError } from "./hook/useHareaError";
import { HareaRoutes } from "./page/HareaRoutes";

const App: React.FC = () => {
    const getHareaCodeInfo = useHareaError();

    const transformError = (error: Error) => {
        return getHareaCodeInfo(error);
    };

    return (
        <AppRoot
            routes={HareaRoutes}
            protectedRoutes="*"
            unProtectedRoutes={UNPROTECTED_ROUTES}
            loginPath={process.env.REACT_APP_LOGIN_URL}
            suspenseFallback={<MainLogo />}
            initialState={[
                { state: SuspenseErrorState, value: { transformError } },
            ]}
        />
    );
};
const UNPROTECTED_ROUTES = [
    "auth/login",
    "auth/signup",
    "auth/forgot-password",
];
export default App;
